import { FC, useEffect } from 'react';

import ButtonComponent from './ButtonComponent';

import { ICONS } from '../utils/enum/Icons';

interface Props {
    message: string;
    type: 'error' | 'success';
    onHide: () => void;
}

const MessageToastComponent: FC<Props> = ({ message, type, onHide }) => {
    useEffect(() => {
        if (message) {
            setTimeout(() => {
                onHide();
            }, 3000);
        }
    }, [message]);

    if (message) {
        return (
            <div className={`br-messageToast`}>
                <div className={`br-messageToast-content ${type}`}>
                    <div className="br-messageToast-content_innerContent">
                        <ButtonComponent text={''} style={'circle-icon'} icon_left={ICONS.close} onClick={onHide} />
                        <p>{message}</p>
                        <div className="round-time-bar" data-style="smooth">
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default MessageToastComponent;
